<template>
  <div class="wizard-footer">
    <div class="wizard-footer__start">
      <slot name="start" />
    </div>
    <div class="wizard-footer__end">
      <slot name="end" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.wizard-footer {
  position: sticky;
  bottom: 0;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(180%) blur(8px);
  border-top: 1px solid var(--phoenix-border-color-translucent);
  padding: 14px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  z-index: 5;
}

.wizard-footer__start {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: var(--phoenix-gray-500);
}

.wizard-footer__end {
  display: flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 768px) {
  .wizard-footer {
    padding: 12px 16px;
    flex-wrap: wrap;
  }
}
</style>
